import { z } from "zod";

export const reminderAssociationSchema = z.object({
  entityType: z.string().min(1, "Entity type is required"),
  entityId: z.string().min(1, "Entity ID is required"),
  notes: z.string().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export const createReminderSchema = z.object({
  title: z.string().min(1, "Title is required").max(255, "Title must be less than 255 characters"),
  date: z.string().min(1, "Date is required"),
  text: z.string().optional(),
  associations: z.array(reminderAssociationSchema).optional(),
  
  // UI-specific fields
  description: z.string().optional(),
  type: z.enum(['appointment', 'follow-up', 'task', 'deadline', 'birthday', 'custom']),
  priority: z.enum(['low', 'medium', 'high', 'urgent']),
  dueDate: z.date(),
  isCompleted: z.boolean().optional(),
  isRecurring: z.boolean().optional(),
  recurringPattern: z.enum(['daily', 'weekly', 'monthly', 'yearly']).optional(),
  reminderTime: z.date({
    message: "Please enter a valid time",
  }),
  associatedClientId: z.string().optional(),
  associatedClientName: z.string().optional(),
  notes: z.string().optional(),
  completedAt: z.date().optional(),
});

export const updateReminderSchema = createReminderSchema.partial();

export type CreateReminderFormData = z.infer<typeof createReminderSchema>;
export type UpdateReminderFormData = z.infer<typeof updateReminderSchema>;
export type ReminderAssociationFormData = z.infer<typeof reminderAssociationSchema>; 